module.exports = __webpack_public_path__ + "static/media/resize-big.c1d5044e.png";